import { CaseProvider, setCaseProvidersList } from '@/store';
import { api } from '../core';
import { CASE_PROVIDERS_TAG } from '../constants';

type DocumentProvidersResponse = CaseProvider[];

interface DocumentProvidersProps {
  caseId?: string;
  abortController?: AbortController;
}

const caseProvidersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCaseProviders: builder.query<DocumentProvidersResponse, DocumentProvidersProps>({
      query: ({ caseId, abortController = new AbortController() }: DocumentProvidersProps) => ({
        url: `provider/list?${caseId ? 'case_id=' + caseId : ''}`,
        method: 'GET',
        signal: abortController.signal
      }),
      providesTags: () => [{ type: CASE_PROVIDERS_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(setCaseProvidersList(data));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getCaseProviders in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetCaseProvidersQuery } = caseProvidersApi;
